<template>
   <div :class="containerStyles" role="search">
    <label for="search-field" class="sr-only">Search</label>
    <input
      id="search-field"
      type="text"
      v-model="inputValue"
      @keyup.enter="handleClick"
      :placeholder="placeholder"
      :class="[
        'flex-grow w-full bg-transparent pb-3 font-bold text-nav-s lg:pb-5 lg:text-l focus:outline-none border-b-4',
        themeType === 'dark'
          ? 'border-white text-white placeholder-white-50'
          : 'border-aubergine text-aubergine placeholder-aubergine-40',
      ]"
    />
    <search-button @click="handleClick" themeType="dark" classes="mb-3 lg:mb-5 -ml-6" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, toRefs } from "vue";
import SearchButton from "@atoms/SearchField/SearchButton.vue";

export interface SearchInputProps {
  placeholder?: string;
  classes?: string;
  themeType?: "dark" | "light";
  subsite?: string;
}

type Emits = {
  (e: "handleClick", inputValue: string): void;
};

const emit = defineEmits<Emits>();

const inputValue = ref("");

const props = withDefaults(defineProps<SearchInputProps>(), {
  placeholder: "Search",
  themeType: "dark",
});

const { placeholder, classes, themeType, subsite } = toRefs(props);

const handleClick = () => {
  emit("handleClick", inputValue.value);
};

const containerStyles = computed(() => {
  let bgColor = subsite?.value == "cowiFonden" ? "bg-green" : "bg-orange";
  return `flex mt-auto items-center cursor-pointer ${classes?.value} ${bgColor}`;
});
</script>
